import EmptyState from '@atlaskit/empty-state/empty-state';
import { FormattedMessage } from 'react-intl';

import { ErrorIllustrationLight } from './illustration-error';
import { type JSX } from 'react/jsx-runtime';

export const ErrorFallback = (): JSX.Element => (
	<EmptyState
		header={''}
		description={
			<>
				<p>
					<FormattedMessage
						id="notifications.error-fallback-error-reason.text"
						description="Informs the user there was a problem"
						defaultMessage="We're unable to load notifications"
					/>
				</p>
				<p style={{ color: 'grey' }}>
					<FormattedMessage
						id="notifications.error-fallback-proposed-solution.text"
						description="Informs the user of a possible solution to the error"
						defaultMessage="Refresh the page or try again later"
					/>
				</p>
			</>
		}
		headingLevel={4}
		renderImage={ErrorIllustrationLight}
	/>
);
